import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SearchforceFindConnectIdEventsComponent } from './find-connect-id-events.component';
import { AuthGuard } from '../core/guards/auth.guard';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: 'searchforce-find-connect-id', component: SearchforceFindConnectIdEventsComponent, canActivate: [AuthGuard],
        data: { label: 'Search for Amway Id Events', parents: ['home'] }
      }
    ])
  ],
  exports: [
    RouterModule
  ]
})
export class FindConnectIdEventsRoutingModule { }
